module.exports = "/_next/static/images/LeverageEvents@2x-56b64ce927703b5b7689e0324f048ef7.png";